import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const saveFavouriteReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_SAVE_FAVOURITE:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_SAVE_FAVOURITE_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_SAVE_FAVOURITE_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_SAVE_FAVOURITE:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default saveFavouriteReducer;
